export const config = {
  apiUrl: window.location.origin,
};
  